<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td
      class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 align-top"
    >
      {{ feature.display_name }}
    </td>
    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 align-top">
      <ul class="space-y-1">
        <li
          v-for="permission in feature.permissions"
          :key="permission.id"
          class="flex gap-3 items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6 text-green-600"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>

          {{ permission.name }}
        </li>
      </ul>
    </td>
    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 sm:pr-6 align-top">
      <FeatureOptionsManager :feature="feature" />
    </td>
  </tr>
</template>

<script>
import FeatureOptionsManager from './FeatureOptionsManager.vue';

export default {
  components: { FeatureOptionsManager },
  props: {
    feature: {
      type: Object,
      required: true,
    },
  },
};
</script>
